import ReactFullpage from "@fullpage/react-fullpage";
import VideoSection from "../../Sections/VideoSection";
import EndSection from "../../Sections/EndSection";
import {useEffect} from "react";
import {Col, Row} from "antd";
import "./index.less"
import "./indexMobile.less"
import MoreButton from "../../MoreButton";
import {isMobile} from "react-device-detect";
import Card from "../../Sections/LatestEventsSection/Card";

const InformationData = [
    {
        date: "2023-7-12",
        title: "世界级涂鸦大师涂绘的背景墙",
        text: "瞩目全球的世界级涂鸦大师在本次活动中为我们精心绘制了一幅壮观的背景墙。他的创作才华与独特风格使得这面墙成为了城市的一张独特名片，吸引了来自世界各地的粉丝及观众。这幅涂鸦壁画将是城市文化的新亮点，必将引发人们的广泛关注和讨论。",
        cover: "/cardCovers/cover6.png",
        url: "https://www.baidu.com",
        type: "A"
    },
    {
        date: "2023-7-12",
        title: "与世界顶级Artists Crossover 跨界营销",
        text: "瞩目全球的世界级涂鸦大师在本次活动中为我们精心绘制了一幅壮观的背景墙。他的创作才华与独特风格使得这面墙成为了城市的一张独特名片，吸引了来自世界各地的粉丝及观众。这幅涂鸦壁画将是城市文化的新亮点，必将引发人们的广泛关注和讨论。",
        cover1: "/cardCovers/cover7.png",
        cover2: "/cardCovers/cover8.png",
        url: "https://www.baidu.com",
        type: "B"
    }, {
        date: "2023-7-12",
        title: "SH-牛仔裤洗水工房开放",
        text: "瞩目全球的世界级涂鸦大师在本次活动中为我们精心绘制了一幅壮观的背景墙。他的创作才华与独特风格使得这面墙成为了城市的一张独特名片，吸引了来自世界各地的粉丝及观众。这幅涂鸦壁画将是城市文化的新亮点，必将引发人们的广泛关注和讨论。",
        cover: "/cardCovers/cover9.png",
        url: "https://www.baidu.com",
        type: "A"
    }, {
        date: "2023-7-12",
        title: "Celia.B 圣诞华丽系列在SOURCE发布",
        text: "瞩目全球的世界级涂鸦大师在本次活动中为我们精心绘制了一幅壮观的背景墙。他的创作才华与独特风格使得这面墙成为了城市的一张独特名片，吸引了来自世界各地的粉丝及观众。这幅涂鸦壁画将是城市文化的新亮点，必将引发人们的广泛关注和讨论。",
        cover1: "/cardCovers/cover10.png",
        cover2: "/cardCovers/cover11.png",
        url: "https://www.baidu.com",
        type: "B"
    },
]

const CardA = ({date, title, text, cover, url}) => {
    return <>
        {!isMobile && <>
            <div className={"card card1"} style={{
                marginLeft: "-40px",
                backgroundImage: `url(${cover})`,
            }}>

            </div>

            <div className={"card text-card1"}
                 style={{marginTop: "-25px", marginLeft: "-60px"}}>

                <div className={"cardDate"} style={{marginTop: "48px"}}>
                    {date}
                </div>

                <div className={"cardTitle"} style={{marginTop: "12px"}}>
                    {title}
                </div>

                <div className={"cardText"} style={{marginTop: "24px"}}>
                    {text}
                </div>

                <div style={{transform: "skew(0deg,2deg)", marginTop: "24px"}}>
                    <MoreButton text={"查看详细"} url={url}/>
                </div>

            </div>
        </>}

        {isMobile && <>
            {/*<div className={"card card1"} style={{*/}
            {/*    width: "282px", height: "240px",*/}
            {/*    // marginLeft: "-40px",*/}
            {/*    backgroundImage: `url(${cover})`,*/}
            {/*}}>*/}

            {/*</div>*/}

            <Card imageUrl={cover} title={title} desc={text} date={date}
                  dateStyle={{
                      // top:"10px !important",
                      marginTop: "50px"
                  }}
                  titleStyle={{
                      marginTop: "30px"
                  }}
            />
        </>
        }
    </>
}

const CardB = ({date, title, text, cover1, cover2, url}) => {
    return <>
        <div className={"card card2"} style={{}}>
            <div className={"cardDate"} style={{marginTop: "48px"}}>
                {date}
            </div>
            <div className={"cardTitle"} style={{marginTop: "12px"}}>
                {title}
            </div>
            <div className={"cardText"} style={{marginTop: "24px"}}>
                {text}
            </div>
            <div style={{transform: "skew(0deg,2deg)", marginTop: "24px"}}>
                <MoreButton text={"查看详细"} url={url}/>
            </div>
        </div>
        <div className={"card card2-img"} style={{
            marginTop: "-18px",
            backgroundImage: `url(${cover1})`
        }}>

        </div>
        <div className={"card card2-img"} style={{
            marginTop: "-35px",
            backgroundImage: `url(${cover2})`
        }}>

        </div>
    </>
}

const PageContent = () => {
    return <>

        {!isMobile && <div className={"section brandOriginContainer"}>
            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer brandInfoTitle"}>
                <div className={"desc"}>
                    Brand Information
                </div>
                <div className={"title"}>
                    品牌资讯
                </div>
            </div>

            <div style={{paddingBottom: "15vh"}}>

                {InformationData.map((item, index) => {
                    switch (item.type) {
                        case "A":
                            return <div className={"cardList"} style={index == 0 ? {marginTop: "300px"} : {}}>
                                <CardA key={index} {...item}/>
                            </div>
                        case "B":
                            return <div className={"cardList"} style={index == 0 ? {marginTop: "300px"} : {}}>
                                <CardB key={index} {...item}/>
                            </div>
                        default:
                            return <></>
                    }
                })}
            </div>
        </div>}

        {isMobile && <div className={"section brandOriginContainer-mobile"}>
            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon rightIcon-info" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer brandInfoTitle"}>
                <div className={"desc"}>
                    Brand Information
                </div>
                <div className={"title"}>
                    品牌资讯
                </div>
            </div>

            <div style={{paddingBottom: "15vh", paddingLeft: "24px"}}>

                {InformationData.map((item, index) => {
                    return <div className={"cardList"} style={index == 0 ? {marginTop: "270px"} : {}}>
                        <CardA key={index} {...item}/>
                    </div>

                    // switch (item.type) {
                    //     case "A":
                    //         return <div className={"cardList"} style={index == 0 ? {marginTop: "300px"} : {}}>
                    //             <CardA key={index} {...item}/>
                    //         </div>
                    //     case "B":
                    //         return <div className={"cardList"} style={index == 0 ? {marginTop: "300px"} : {}}>
                    //             <CardB key={index} {...item}/>
                    //         </div>
                    //     default:
                    //         return <></>
                    // }
                })}
            </div>
        </div>}

    </>
}

export default () => {
    useEffect(() => {
        const watermark = document.querySelector(".fp-watermark");
        watermark && watermark.remove();
    }, [])

    return <div>
        <ReactFullpage
            licenseKey={'YOUR_KEY_HERE'}
            scrollingSpeed={1000}
            loopTop={false}
            loopBottom={false}
            anchors={['bi1', 'bi2']}
            render={({state, fullpageApi}) => {
                return (
                    <ReactFullpage.Wrapper>
                        <PageContent/>
                        <EndSection/>
                    </ReactFullpage.Wrapper>
                );
            }}
        />
    </div>
}